import { useEffect, useRef } from "react";

/* ----- Small SVG decor objects rendered inside the shelf niches ----- */
const objStyle = {
  position: "absolute",
  left: "50%",
  bottom: "4%",
  transform: "translateX(-50%)",
  width: "88%",
  height: "88%",
  zIndex: 2,
  pointerEvents: "none",
  filter: "drop-shadow(0 4px 6px rgba(0,0,0,0.55))",
};

function PlantMonstera() {
  return (
    <svg style={objStyle} viewBox="0 0 50 70" preserveAspectRatio="xMidYMax meet">
      <g fill="#0a0807">
        <ellipse cx="18" cy="30" rx="6" ry="20" transform="rotate(-28 18 30)" />
        <ellipse cx="32" cy="28" rx="6" ry="22" transform="rotate(24 32 28)" />
        <ellipse cx="25" cy="22" rx="5.5" ry="24" />
        <ellipse cx="14" cy="40" rx="5" ry="14" transform="rotate(-50 14 40)" />
        <ellipse cx="36" cy="40" rx="5" ry="14" transform="rotate(50 36 40)" />
      </g>
      {/* leaf rim highlights from spotlight */}
      <path d="M25 5 Q22 25 24 45" stroke="rgba(245,210,120,0.35)" strokeWidth="0.5" fill="none" />
      <path d="M18 18 Q15 32 16 45" stroke="rgba(245,210,120,0.25)" strokeWidth="0.4" fill="none" />
      {/* pot */}
      <path d="M14 50 L36 50 L34 68 L16 68 Z" fill="#1a1410" stroke="rgba(212,175,55,0.45)" strokeWidth="0.5" />
      <ellipse cx="25" cy="50" rx="11" ry="2" fill="#06050a" />
      <line x1="14" y1="54" x2="36" y2="54" stroke="rgba(212,175,55,0.35)" strokeWidth="0.4" />
    </svg>
  );
}

function PlantPalm() {
  return (
    <svg style={objStyle} viewBox="0 0 50 70" preserveAspectRatio="xMidYMax meet">
      <g fill="#0a0807">
        {/* thin palm fronds */}
        {[-45, -30, -15, 0, 15, 30, 45].map((r, i) => (
          <ellipse key={i} cx="25" cy="22" rx="1.6" ry="20" transform={`rotate(${r} 25 26)`} />
        ))}
        {/* secondary fronds */}
        {[-60, -50, 50, 60].map((r, i) => (
          <ellipse key={i} cx="25" cy="28" rx="1.4" ry="14" transform={`rotate(${r} 25 32)`} />
        ))}
      </g>
      {/* rim highlight */}
      <g stroke="rgba(245,210,120,0.3)" strokeWidth="0.35" fill="none">
        <path d="M25 10 L25 45" />
        <path d="M14 16 L24 30" />
        <path d="M36 16 L26 30" />
      </g>
      {/* pot */}
      <path d="M15 50 L35 50 L33 68 L17 68 Z" fill="#1a1410" stroke="rgba(212,175,55,0.45)" strokeWidth="0.5" />
      <ellipse cx="25" cy="50" rx="10" ry="2" fill="#06050a" />
      <line x1="15" y1="54" x2="35" y2="54" stroke="rgba(212,175,55,0.35)" strokeWidth="0.4" />
    </svg>
  );
}

function PlantSucculent() {
  return (
    <svg style={objStyle} viewBox="0 0 50 70" preserveAspectRatio="xMidYMax meet">
      <g fill="#0a0807">
        {/* rosette of round leaves */}
        {[
          [25, 38, 8, 6],
          [16, 40, 5, 7],
          [34, 40, 5, 7],
          [20, 32, 5, 8],
          [30, 32, 5, 8],
          [25, 28, 4, 7],
        ].map(([cx, cy, rx, ry], i) => (
          <ellipse key={i} cx={cx} cy={cy} rx={rx} ry={ry} />
        ))}
      </g>
      {/* rim highlights */}
      <g stroke="rgba(245,210,120,0.32)" strokeWidth="0.4" fill="none">
        <ellipse cx="25" cy="28" rx="4" ry="7" />
        <ellipse cx="20" cy="32" rx="5" ry="8" />
        <ellipse cx="30" cy="32" rx="5" ry="8" />
      </g>
      {/* shallow pot */}
      <path d="M12 48 L38 48 L36 60 L14 60 Z" fill="#1a1410" stroke="rgba(212,175,55,0.45)" strokeWidth="0.5" />
      <ellipse cx="25" cy="48" rx="13" ry="2" fill="#06050a" />
    </svg>
  );
}

function StatueBust() {
  return (
    <svg style={objStyle} viewBox="0 0 50 70" preserveAspectRatio="xMidYMax meet">
      {/* head */}
      <ellipse cx="25" cy="20" rx="9" ry="11" fill="#0a0807" />
      {/* hair detail */}
      <path d="M16 18 Q19 8 25 9 Q31 8 34 18" fill="#050302" />
      {/* neck */}
      <rect x="22" y="29" width="6" height="6" fill="#0a0807" />
      {/* shoulders / chest */}
      <path d="M12 36 Q25 32 38 36 L40 50 L10 50 Z" fill="#0a0807" />
      {/* rim highlight */}
      <path d="M16 14 Q18 8 25 7" stroke="rgba(245,210,120,0.4)" strokeWidth="0.5" fill="none" />
      <path d="M14 38 Q25 34 36 38" stroke="rgba(245,210,120,0.3)" strokeWidth="0.5" fill="none" />
      {/* pedestal */}
      <rect x="12" y="50" width="26" height="4" fill="#1a1410" stroke="rgba(212,175,55,0.5)" strokeWidth="0.4" />
      <rect x="14" y="54" width="22" height="12" fill="#1a1410" stroke="rgba(212,175,55,0.45)" strokeWidth="0.4" />
      <rect x="10" y="66" width="30" height="3" fill="#1a1410" stroke="rgba(212,175,55,0.5)" strokeWidth="0.4" />
      <line x1="14" y1="60" x2="36" y2="60" stroke="rgba(212,175,55,0.3)" strokeWidth="0.3" />
    </svg>
  );
}

function StatueFigure() {
  return (
    <svg style={objStyle} viewBox="0 0 50 70" preserveAspectRatio="xMidYMax meet">
      {/* head */}
      <circle cx="25" cy="10" r="4.5" fill="#0a0807" />
      {/* body / draped robe */}
      <path
        d="M19 16 Q21 24 20 36 Q18 46 16 56 L34 56 Q32 46 30 36 Q29 24 31 16 Q28 14 25 14 Q22 14 19 16 Z"
        fill="#0a0807"
      />
      {/* drape folds */}
      <g stroke="rgba(245,210,120,0.28)" strokeWidth="0.4" fill="none">
        <path d="M21 20 Q20 36 18 54" />
        <path d="M25 18 Q25 36 24 54" />
        <path d="M29 20 Q30 36 32 54" />
      </g>
      {/* rim highlight on head */}
      <path d="M21 7 Q22 5 25 5" stroke="rgba(245,210,120,0.45)" strokeWidth="0.5" fill="none" />
      {/* pedestal */}
      <rect x="11" y="56" width="28" height="3" fill="#1a1410" stroke="rgba(212,175,55,0.5)" strokeWidth="0.4" />
      <rect x="13" y="59" width="24" height="8" fill="#1a1410" stroke="rgba(212,175,55,0.45)" strokeWidth="0.4" />
      <rect x="10" y="67" width="30" height="2" fill="#1a1410" stroke="rgba(212,175,55,0.5)" strokeWidth="0.4" />
    </svg>
  );
}

function StatueAbstract() {
  return (
    <svg style={objStyle} viewBox="0 0 50 70" preserveAspectRatio="xMidYMax meet">
      {/* organic abstract form */}
      <path
        d="M25 6
           Q34 14 30 26
           Q26 36 32 44
           Q36 52 25 56
           Q14 52 18 44
           Q24 36 20 26
           Q16 14 25 6 Z"
        fill="#0a0807"
      />
      {/* highlight */}
      <path
        d="M25 6 Q32 14 29 26 Q26 34 30 42"
        stroke="rgba(245,210,120,0.4)"
        strokeWidth="0.5"
        fill="none"
      />
      {/* hole through center for visual interest */}
      <ellipse cx="25" cy="30" rx="3" ry="6" fill="#fdfaf3" opacity="0.65" />
      {/* pedestal */}
      <rect x="11" y="56" width="28" height="3" fill="#1a1410" stroke="rgba(212,175,55,0.5)" strokeWidth="0.4" />
      <rect x="13" y="59" width="24" height="8" fill="#1a1410" stroke="rgba(212,175,55,0.45)" strokeWidth="0.4" />
      <rect x="10" y="67" width="30" height="2" fill="#1a1410" stroke="rgba(212,175,55,0.5)" strokeWidth="0.4" />
    </svg>
  );
}

/**
 * EntertainmentCenter — pure-CSS animated scene for the hero background.
 * First-person POV: viewer is sitting on a charcoal couch (silhouette in
 * foreground) looking at a custom luxury entertainment center with
 * color-cycling LEDs, a sound bar, and floor-standing tower speakers.
 */
export default function EntertainmentCenter() {
  const sceneRef = useRef(null);

  // Subtle parallax based on mouse position (desktop only)
  useEffect(() => {
    const el = sceneRef.current;
    if (!el) return;
    if (window.matchMedia("(hover: none)").matches) return;
    let raf = 0;
    const onMove = (e) => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const rect = el.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width - 0.5;
        const y = (e.clientY - rect.top) / rect.height - 0.5;
        el.style.setProperty("--px", `${x * -10}px`);
        el.style.setProperty("--py", `${y * -6}px`);
      });
    };
    window.addEventListener("mousemove", onMove);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={sceneRef}
      className="ec-scene"
      data-testid="hero-entertainment-center"
      aria-hidden="true"
    >
      {/* Room ambient light wash */}
      <div className="ec-ambient" />

      {/* Back wall with vertical slat pattern */}
      <div className="ec-wall">
        <div className="ec-slats" />
        {/* Crown molding band along the top */}
        <div className="ec-crown" />
      </div>

      {/* Wall sconces flanking the EC — gold body + warm glow */}
      <div className="ec-sconce ec-sconce-left">
        <div className="ec-sconce-body" />
        <div className="ec-sconce-glow" />
      </div>
      <div className="ec-sconce ec-sconce-right">
        <div className="ec-sconce-body" />
        <div className="ec-sconce-glow" />
      </div>

      {/* Tower speakers on the floor — left & right of the EC */}
      <div className="ec-speaker ec-speaker-left">
        <div className="ec-spk-cone ec-spk-tweeter">
          <span />
        </div>
        <div className="ec-spk-cone ec-spk-mid">
          <span />
        </div>
        <div className="ec-spk-cone ec-spk-woofer">
          <span />
        </div>
        <div className="ec-spk-led" />
      </div>
      <div className="ec-speaker ec-speaker-right">
        <div className="ec-spk-cone ec-spk-tweeter">
          <span />
        </div>
        <div className="ec-spk-cone ec-spk-mid">
          <span />
        </div>
        <div className="ec-spk-cone ec-spk-woofer">
          <span />
        </div>
        <div className="ec-spk-led" />
      </div>

      {/* Entertainment center frame */}
      <div className="ec-frame">
        {/* Procedural marble back panel (SVG) — dark with warm gold veining */}
        <svg
          className="ec-marble-svg"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 600 800"
          aria-hidden="true"
        >
          <defs>
            <filter id="marbleNoise" x="0" y="0" width="100%" height="100%">
              <feTurbulence
                type="fractalNoise"
                baseFrequency="0.012 0.05"
                numOctaves="3"
                seed="7"
                result="t"
              />
              <feColorMatrix
                in="t"
                type="matrix"
                values="
                  0.20 0 0 0 0.92
                  0.18 0 0 0 0.90
                  0.14 0 0 0 0.84
                  0    0 0 0 1"
              />
              <feGaussianBlur stdDeviation="0.4" />
            </filter>
            <filter id="marbleDisplace" x="-5%" y="-5%" width="110%" height="110%">
              <feTurbulence type="turbulence" baseFrequency="0.008 0.012" numOctaves="2" seed="3" />
              <feDisplacementMap in="SourceGraphic" scale="28" />
            </filter>
            <radialGradient id="marbleBase" cx="35%" cy="35%" r="85%">
              <stop offset="0%" stopColor="#fdfaf3" />
              <stop offset="55%" stopColor="#f0e9da" />
              <stop offset="100%" stopColor="#d8cbb0" />
            </radialGradient>
            <linearGradient id="marbleVeinG" x1="0" x2="1" y1="0" y2="1">
              <stop offset="0%" stopColor="rgba(180,140,55,0)" />
              <stop offset="40%" stopColor="rgba(184,140,44,0.9)" />
              <stop offset="55%" stopColor="rgba(245,210,120,1)" />
              <stop offset="70%" stopColor="rgba(184,140,44,0.85)" />
              <stop offset="100%" stopColor="rgba(180,140,55,0)" />
            </linearGradient>
            <linearGradient id="marbleVeinFine" x1="0" x2="1" y1="0" y2="1">
              <stop offset="0%" stopColor="rgba(120,90,30,0)" />
              <stop offset="50%" stopColor="rgba(140,100,40,0.55)" />
              <stop offset="100%" stopColor="rgba(120,90,30,0)" />
            </linearGradient>
          </defs>

          {/* Base creamy marble */}
          <rect width="100%" height="100%" fill="url(#marbleBase)" />

          {/* Procedural marble dust noise */}
          <rect width="100%" height="100%" filter="url(#marbleNoise)" opacity="0.55" />

          {/* Bold gold veins drawn with displaced paths */}
          <g filter="url(#marbleDisplace)">
            <path
              d="M -20 180 Q 120 130 240 200 T 480 220 T 640 180"
              stroke="url(#marbleVeinG)"
              strokeWidth="4"
              fill="none"
            />
            <path
              d="M -20 340 Q 160 290 280 380 T 520 360 T 640 380"
              stroke="url(#marbleVeinG)"
              strokeWidth="3"
              fill="none"
              opacity="0.9"
            />
            <path
              d="M -20 540 Q 100 490 260 560 T 460 540 T 640 560"
              stroke="url(#marbleVeinG)"
              strokeWidth="2.6"
              fill="none"
              opacity="0.85"
            />
            <path
              d="M 80 -20 Q 130 180 100 380 T 140 740"
              stroke="url(#marbleVeinG)"
              strokeWidth="2.4"
              fill="none"
              opacity="0.8"
            />
            <path
              d="M 480 -20 Q 460 220 510 420 T 530 740"
              stroke="url(#marbleVeinG)"
              strokeWidth="2.2"
              fill="none"
              opacity="0.8"
            />
            {/* Fine branching gold threads */}
            <path
              d="M 100 100 Q 180 160 200 230 T 280 360"
              stroke="url(#marbleVeinFine)"
              strokeWidth="1.4"
              fill="none"
            />
            <path
              d="M 360 60 Q 400 200 420 320 T 460 540"
              stroke="url(#marbleVeinFine)"
              strokeWidth="1.4"
              fill="none"
            />
            <path
              d="M 200 480 Q 280 540 340 620 T 420 740"
              stroke="url(#marbleVeinFine)"
              strokeWidth="1.2"
              fill="none"
            />
          </g>

          {/* Polished sheen (light from top) */}
          <rect
            width="100%"
            height="35%"
            fill="rgba(255,255,255,0.18)"
            style={{ mixBlendMode: "screen" }}
          />
        </svg>

        {/* Gold molding frame around the entire EC */}
        <div className="ec-gold-frame" />

        {/* Stone header band */}
        <div className="ec-stone-top" />

        {/* Three pinpoint downlights above TV */}
        <div className="ec-downlights">
          <span style={{ "--d": "0s" }} />
          <span style={{ "--d": ".6s" }} />
          <span style={{ "--d": "1.2s" }} />
        </div>

        {/* Left shelf column: Plant · Statue · Plant */}
        <div className="ec-shelf ec-shelf-left">
          <div className="ec-niche" style={{ "--delay": "0s" }}>
            <span className="ec-niche-spot" />
            <span className="ec-niche-glow" />
            <PlantMonstera />
          </div>
          <div className="ec-niche" style={{ "--delay": "2s" }}>
            <span className="ec-niche-spot" />
            <span className="ec-niche-glow" />
            <StatueBust />
          </div>
          <div className="ec-niche" style={{ "--delay": "4s" }}>
            <span className="ec-niche-spot" />
            <span className="ec-niche-glow" />
            <PlantSucculent />
          </div>
        </div>

        {/* Right shelf column: Statue · Plant · Statue */}
        <div className="ec-shelf ec-shelf-right">
          <div className="ec-niche" style={{ "--delay": "1s" }}>
            <span className="ec-niche-spot" />
            <span className="ec-niche-glow" />
            <StatueFigure />
          </div>
          <div className="ec-niche" style={{ "--delay": "3s" }}>
            <span className="ec-niche-spot" />
            <span className="ec-niche-glow" />
            <PlantPalm />
          </div>
          <div className="ec-niche" style={{ "--delay": "5s" }}>
            <span className="ec-niche-spot" />
            <span className="ec-niche-glow" />
            <StatueAbstract />
          </div>
        </div>

        {/* Center: TV with bias-light halo + screen content shimmer */}
        <div className="ec-tv-wrap">
          {/* Big soft halo bleeding onto the wall behind the TV */}
          <div className="ec-tv-halo" />
          {/* Thin bias-light strip hugging the back edge of the TV */}
          <div className="ec-tv-bias" />
          {/* Gold metallic bezel around the TV */}
          <div className="ec-tv-bezel" />
          <div className="ec-tv">
            <div className="ec-tv-screen" />
            {/* Branded promo video playing on the TV */}
            <video
              className="ec-tv-video"
              src="https://customer-assets.emergentagent.com/job_luxury-walls-preview/artifacts/w3ew6alg_gemini_generated_video_A39FD044.MP4"
              poster="https://customer-assets.emergentagent.com/job_7e8193e0-edce-43f5-a1f7-0a85ea9e900a/artifacts/j0n8bmmw_image.png"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              data-testid="hero-tv-video"
            />
            <div className="ec-tv-reflect" />
          </div>
        </div>

        {/* Sound bar under the TV */}
        <div className="ec-soundbar">
          <div className="ec-soundbar-driver" />
          <div className="ec-soundbar-driver" />
          <div className="ec-soundbar-grille" />
          <div className="ec-soundbar-driver" />
          <div className="ec-soundbar-driver" />
          <div className="ec-soundbar-led" />
        </div>

        {/* Bottom console with underglow LED strip */}
        <div className="ec-console">
          <div className="ec-stone-bottom" />
          <div className="ec-led-strip" />
        </div>
      </div>

      {/* Floor with soft reflection */}
      <div className="ec-floor">
        {/* Subtle wood-grain reflection of TV light */}
        <div className="ec-floor-reflect" />
        {/* Area rug under the coffee table */}
        <div className="ec-rug" />
      </div>

      {/* Coffee table + remote in foreground — deepens POV illusion */}
      <svg
        className="ec-table"
        viewBox="0 0 1920 260"
        preserveAspectRatio="none"
        focusable="false"
      >
        <defs>
          <linearGradient id="tableTop" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#1a1a1d" />
            <stop offset="60%" stopColor="#0e0e10" />
            <stop offset="100%" stopColor="#070708" />
          </linearGradient>
          <linearGradient id="tableEdge" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="rgba(255,255,255,0.16)" />
            <stop offset="100%" stopColor="rgba(255,255,255,0)" />
          </linearGradient>
          <radialGradient id="tableReflect" cx="50%" cy="0%" r="65%">
            <stop offset="0%" stopColor="rgba(212,175,55,0.18)" />
            <stop offset="60%" stopColor="rgba(212,175,55,0)" />
          </radialGradient>
        </defs>
        {/* Shadow under table */}
        <ellipse cx="960" cy="240" rx="650" ry="14" fill="rgba(0,0,0,0.55)" />
        {/* Table top — trapezoid for perspective */}
        <path
          d="M460 90 L1460 90 L1620 170 L300 170 Z"
          fill="url(#tableTop)"
          stroke="#1d1d20"
          strokeWidth="1"
        />
        {/* Front edge highlight */}
        <path
          d="M300 170 L1620 170"
          stroke="rgba(255,255,255,0.10)"
          strokeWidth="1.5"
        />
        {/* Subtle screen-glow reflection on the top */}
        <path
          d="M460 90 L1460 90 L1620 170 L300 170 Z"
          fill="url(#tableReflect)"
        />
        {/* Coaster / decorative circle */}
        <ellipse cx="660" cy="130" rx="38" ry="6" fill="rgba(0,0,0,0.5)" />
        <ellipse cx="660" cy="128" rx="34" ry="5" fill="#101012" stroke="#1d1d20" strokeWidth="0.5" />

        {/* Coffee cup + rising steam */}
        <g className="ec-coffee">
          {/* Saucer */}
          <ellipse cx="820" cy="138" rx="34" ry="6" fill="rgba(0,0,0,0.55)" />
          <ellipse cx="820" cy="136" rx="30" ry="5" fill="#15151a" stroke="#26262a" strokeWidth="0.6" />
          {/* Cup body */}
          <path
            d="M800 100 Q800 130 820 132 Q840 130 840 100 Z"
            fill="#1a1a1d"
            stroke="#2a2a2e"
            strokeWidth="0.7"
          />
          {/* Cup top opening (dark coffee surface) */}
          <ellipse cx="820" cy="100" rx="20" ry="4" fill="#06060a" stroke="#2a2a2e" strokeWidth="0.5" />
          {/* Coffee surface glint */}
          <ellipse cx="816" cy="99" rx="6" ry="1.2" fill="rgba(212,175,55,0.18)" />
          {/* Handle */}
          <path
            d="M840 108 Q852 112 850 122 Q848 128 838 126"
            fill="none"
            stroke="#26262a"
            strokeWidth="2"
            strokeLinecap="round"
          />
          {/* Steam wisps — animated */}
          <g className="ec-steam" opacity="0.55">
            <path
              className="ec-steam-1"
              d="M810 96 Q815 84 808 72 Q802 60 812 48"
              fill="none"
              stroke="rgba(255,255,255,0.55)"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
            <path
              className="ec-steam-2"
              d="M820 96 Q825 80 818 66 Q812 54 822 40"
              fill="none"
              stroke="rgba(255,255,255,0.5)"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
            <path
              className="ec-steam-3"
              d="M830 96 Q834 82 828 68 Q822 56 832 42"
              fill="none"
              stroke="rgba(255,255,255,0.45)"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
          </g>
        </g>
        {/* Remote */}
        <g>
          <rect
            x="1060"
            y="110"
            width="190"
            height="32"
            rx="6"
            fill="#101012"
            stroke="#1d1d20"
          />
          {/* Remote highlight */}
          <rect
            x="1060"
            y="110"
            width="190"
            height="6"
            rx="6"
            fill="url(#tableEdge)"
          />
          {/* Buttons */}
          <circle cx="1090" cy="126" r="3" fill="#27272a" />
          <circle cx="1110" cy="126" r="3" fill="#27272a" />
          <circle cx="1140" cy="126" r="4" fill="#D4AF37" opacity="0.85" />
          <circle cx="1170" cy="126" r="3" fill="#27272a" />
          <circle cx="1190" cy="126" r="3" fill="#27272a" />
          <circle cx="1220" cy="126" r="3" fill="#27272a" />
        </g>
        {/* Small ambient highlight on remote (from TV) */}
        <rect
          x="1060"
          y="108"
          width="190"
          height="2"
          fill="rgba(255,255,255,0.12)"
        />
      </svg>

      {/* Foreground couch silhouette (POV) — lighter charcoal */}
      <svg
        className="ec-couch"
        viewBox="0 0 1920 460"
        preserveAspectRatio="none"
        focusable="false"
      >
        <defs>
          <linearGradient id="couchG" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#27272a" />
            <stop offset="55%" stopColor="#18181b" />
            <stop offset="100%" stopColor="#0b0b0d" />
          </linearGradient>
          <linearGradient id="couchTopLight" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="rgba(255,255,255,0.18)" />
            <stop offset="100%" stopColor="rgba(255,255,255,0)" />
          </linearGradient>
          <radialGradient id="couchAmbient" cx="50%" cy="20%" r="60%">
            <stop offset="0%" stopColor="rgba(212,175,55,0.18)" />
            <stop offset="60%" stopColor="rgba(212,175,55,0)" />
          </radialGradient>
          <filter id="couchBlur">
            <feGaussianBlur stdDeviation="1.2" />
          </filter>
        </defs>

        {/* Soft ambient gold wash on couch top (from screen) */}
        <ellipse cx="960" cy="200" rx="900" ry="120" fill="url(#couchAmbient)" />

        {/* Main couch silhouette */}
        <path
          d="M0 460 L0 250 Q140 165 360 188 Q620 215 960 208 Q1300 200 1560 188 Q1780 175 1920 250 L1920 460 Z"
          fill="url(#couchG)"
        />

        {/* Top rim highlight — reads couch top edge */}
        <path
          d="M0 252 Q140 168 360 191 Q620 218 960 211 Q1300 203 1560 191 Q1780 178 1920 252"
          stroke="rgba(255,255,255,0.22)"
          strokeWidth="2"
          fill="none"
          filter="url(#couchBlur)"
        />

        {/* Headrest left bump */}
        <ellipse cx="220" cy="200" rx="240" ry="60" fill="#1f1f23" />
        <path
          d="M30 215 Q220 152 410 215"
          stroke="rgba(255,255,255,0.14)"
          strokeWidth="1.4"
          fill="none"
        />

        {/* Throw blanket draped over the LEFT armrest */}
        <g className="ec-throw">
          <defs>
            <linearGradient id="throwG" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#c8b48a" />
              <stop offset="55%" stopColor="#9a8559" />
              <stop offset="100%" stopColor="#5d4f33" />
            </linearGradient>
            <linearGradient id="throwHi" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="rgba(255,255,255,0.18)" />
              <stop offset="100%" stopColor="rgba(255,255,255,0)" />
            </linearGradient>
          </defs>
          {/* Main draped shape — falls over the top of the left bump and down the front */}
          <path
            d="M70 190
               Q150 150 290 168
               Q360 178 410 210
               Q380 250 360 295
               Q345 335 330 380
               L260 395
               Q235 360 210 320
               Q175 280 130 250
               Q90 225 60 215 Z"
            fill="url(#throwG)"
          />
          {/* Soft top highlight catching ambient light */}
          <path
            d="M80 188 Q170 152 290 168 Q360 178 408 208"
            fill="none"
            stroke="rgba(255,255,255,0.22)"
            strokeWidth="1.2"
          />
          {/* Fold shadows */}
          <path
            d="M170 185 Q190 240 210 320"
            stroke="rgba(0,0,0,0.32)"
            strokeWidth="2"
            fill="none"
          />
          <path
            d="M240 175 Q260 240 290 340"
            stroke="rgba(0,0,0,0.28)"
            strokeWidth="2"
            fill="none"
          />
          <path
            d="M310 178 Q330 240 350 360"
            stroke="rgba(0,0,0,0.24)"
            strokeWidth="2"
            fill="none"
          />
          {/* Subtle weave texture lines */}
          <path
            d="M100 220 L390 215"
            stroke="rgba(0,0,0,0.18)"
            strokeWidth="0.6"
            fill="none"
          />
          <path
            d="M130 250 L380 250"
            stroke="rgba(0,0,0,0.16)"
            strokeWidth="0.6"
            fill="none"
          />
          {/* Tasseled fringe at the bottom */}
          {Array.from({ length: 9 }).map((_, i) => {
            const x = 270 + i * 9;
            const y = 380 + (i % 2) * 4;
            return (
              <line
                key={i}
                x1={x}
                y1={y}
                x2={x + 1}
                y2={y + 14}
                stroke="#7a6840"
                strokeWidth="1.2"
                strokeLinecap="round"
              />
            );
          })}
          {/* Top gloss */}
          <path
            d="M70 190 Q150 150 290 168 Q360 178 410 210 L410 220 Q360 192 290 180 Q150 168 70 200 Z"
            fill="url(#throwHi)"
            opacity="0.6"
          />
        </g>
        {/* Headrest right bump */}
        <ellipse cx="1700" cy="200" rx="240" ry="60" fill="#1f1f23" />
        <path
          d="M1510 215 Q1700 152 1890 215"
          stroke="rgba(255,255,255,0.14)"
          strokeWidth="1.4"
          fill="none"
        />

        {/* Middle cushion section with seams */}
        <path
          d="M500 230 Q700 215 960 212 Q1220 215 1420 230"
          stroke="rgba(255,255,255,0.10)"
          strokeWidth="1.2"
          fill="none"
        />
        {/* Vertical cushion seams */}
        <line x1="720" y1="220" x2="720" y2="380" stroke="rgba(0,0,0,0.6)" strokeWidth="1.5" />
        <line x1="960" y1="215" x2="960" y2="385" stroke="rgba(0,0,0,0.6)" strokeWidth="1.5" />
        <line x1="1200" y1="220" x2="1200" y2="380" stroke="rgba(0,0,0,0.6)" strokeWidth="1.5" />

        {/* Tufting dots */}
        {[
          [820, 290],
          [1100, 290],
          [820, 340],
          [1100, 340],
          [600, 320],
          [1320, 320],
        ].map(([cx, cy], i) => (
          <circle
            key={i}
            cx={cx}
            cy={cy}
            r="3"
            fill="rgba(0,0,0,0.6)"
          />
        ))}

        {/* Faint top light band (catches TV glow) */}
        <rect x="0" y="245" width="1920" height="20" fill="url(#couchTopLight)" />
      </svg>
    </div>
  );
}
